import { make } from 'vuex-pathify'

const state = {
    enrollments: null,
    selectedIdx: null,
}

const getters = {
    selected(state) {
        if (state.selectedIdx !== null) {
            return state.enrollments[state.selectedIdx]
        }
    },

    isSelectedActive(state, getters) {
        return !!getters.selected && getters.selected.is_active
    },
}

// const mutations = {
//     ...make.mutations(state),
//
//     SET_ENROLLMENTS(state, value) {
//         const nextValue = value instanceof Payload
//             ? value.update(state[key])
//             : value
//
//         Vue.set(state, nextValue)
//     }
// }

const actions = {
    selectByPeriodId({ state, commit }, periodId) {
        commit(
            'SET_SELECTED_IDX',
            state.enrollments.findIndex(period => period.id == periodId)
        )
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations: make.mutations(state)
}
